import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  EditorialFocus,
  PlanOroInvestment,
  WhyAlliance,
  ClosingPitch,
  AreYouReady,
} from './components';

const LandingMediaKitHoetPartners = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Hero themeMode={themeMode} />
      </Container>
      <Container>
        <EditorialFocus />
      </Container>
      <Container>
        <PlanOroInvestment />
      </Container>
      <Container>
        <WhyAlliance />
      </Container>
      <Container>
        <ClosingPitch />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitHoetPartners.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitHoetPartners;
